<template lang="pug">
#sitemap
  .container.i_pb_12
    .row.i_mt_10
      .col.text-center
        h2.i_h2_title 網站地圖
    .row.justify-content-center
      .col-auto.col-lg-3.first_col
        ul.top
          li 網站導覽與聲明
          li
            router-link(tag="a", :to="{ name: 'CustomerProtectionStatement' }") 客戶保護及聲明事項
          li
            a(href="/customize/Trafficsafetyzone") 交通安全宣導專區
          li
            a(href="https://easyaccess.tmnewa.com.tw/", target="_blank") 友善服務網站
        ul.d-block.d-md-block.d-lg-none
          li 認識新安
          li 
            router-link(tag="a", :to="{ name: 'AboutUsProfile' }") 公司簡介
          li 
            router-link(tag="a", :to="{ name: 'AboutUsPublicInfo' }") 公開資訊
          li 
            router-link(tag="a", :to="{ name: 'AboutUsGovernance' }") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li
            router-link(tag="a", :to="{ name: 'ShareholderServices' }") 股東專區
          li
            router-link(tag="a", :to="{ name: 'AboutUsNews' }") 最新消息
          li 
            router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }") 商業合作
          li
            a(href="/customize/manager") 公平待客
        ul.d-none.d-md-none.d-lg-block
          li 加入我們
          li 
            a(
              href="https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1",
              target="_blank"
            ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li 
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
      .col-auto.col-lg-3
        ul.top
          li 商品櫥窗
          li(v-for="product in productCategory.ProductCategoryList") 
            p(style="cursor: pointer", @click="toPageWindow(product)") {{ product.ProductCategoryName }}
        ul.d-none.d-md-none.d-lg-block
          li 友站連結
          li(v-for="link in siteMap.LinkList")
            a(target="_blank", :href="link.URL") {{ link.Name }}
        ul.d-block.d-md-block.d-lg-none
          li 加入我們
          li 
            a(
              href="https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1",
              target="_blank"
            ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li 
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
      .col-auto.col-lg-3
        ul.top
          li 客戶服務
          li 
            router-link(
              tag="a",
              :to="{ name: 'CustomerServiceClaimSettlement' }"
            ) 理賠服務
          li 
            router-link(
              tag="a",
              :to="{ name: 'CustomerServicePaymentService' }"
            ) 繳費服務
          li 
            router-link(tag="a", :to="{ name: 'CustomerServiceFAQ' }") 常見問題
          li 
            router-link(
              tag="a",
              :to="{ name: 'CustomerServiceDocumentDownload' }"
            ) 文件下載
          li 
            router-link(
              tag="a",
              :to="{ name: 'CustomerServiceCompulsoryLicense' }"
            ) 強制證下載
          li(v-if="false")
            router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }") 聯絡我們
          li 
            router-link(tag="a", :to="{ name: 'Location' }") 服務據點
        ul.d-block.d-md-block.d-lg-none
          li 友站連結
          li(v-for="link in siteMap.LinkList")
            a(target="_blank", :href="link.URL") {{ link.Name }}
      .col-lg-3.d-none.d-lg-block
        ul.top
          li 認識新安
          li 
            router-link(tag="a", :to="{ name: 'AboutUsProfile' }") 公司簡介
          li 
            router-link(tag="a", :to="{ name: 'AboutUsPublicInfo' }") 公開資訊
          li 
            router-link(tag="a", :to="{ name: 'AboutUsGovernance' }") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li
            router-link(tag="a", :to="{ name: 'ShareholderServices' }") 股東專區
          li
            router-link(tag="a", :to="{ name: 'AboutUsNews' }") 最新消息
          li 
            router-link(tag="a", :to="{ name: 'CustomerServiceContactUs' }") 商業合作
          li
            a(href="/customize/manager") 公平待客
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import { getSiteMap, getHotKeyword } from "@/json/menu";
import { getProductCategory } from "@/json/product";

export default {
  name: "Sitemap",
  components: {
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      siteMap: {},
      hotKeyword: {},
      productCategory: {},
    };
  },
  created() {
    this.getSiteMap();
    this.getHotKeyword();
    this.getProductCategory();
  },
  methods: {
    getSiteMap() {
      getSiteMap().then((response) => {
        this.siteMap = response.data;
      });
    },
    getHotKeyword() {
      getHotKeyword().then((response) => {
        this.hotKeyword = response.data;
      });
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
      });
    },
    toPageWindow(product) {
      if (product && product.ProductList.length > 0) {
        this.$router.push({
          name: "ProductIntro",
          params: {
            type: product.ProductList[0].ProductJson,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/guide_and_declaration/sitemap.scss";
</style>
